import '@css/main.scss'
import '@js/bootstrap'

import {Header} from '@js/components/Header'
import {Scroll} from '@js/animations/Scroll'
import Loader from "@js/components/Loader";
import {Slider} from "@js/components/Slider";
import LightBox from "@js/components/LightBox";
import Tabs from "@js/components/Tabs";
import PrintVehicule from "@js/components/PrintVehicule";


window.onload = () => {

  const animations = [
    Scroll
  ]

  animations.forEach(animation => {
    new animation()
  })

  new Header();
  new Loader();
  new Slider();
  new LightBox();
  new Tabs();
  new PrintVehicule();
}
